const e = {
  name: "RevenueProtect",
  dimensions: { width: 18, height: 22 },
  content: `
    <svg fill="currentColor">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M17.0554 1.90967C11.9844 -0.625815 6.0156 -0.625815 0.944628 1.90967C0.365698 2.19914 0 2.79085 0 3.43811V10.8507C0 13.1113 0.733208 15.311 2.08957 17.1194C2.90051 18.2007 3.91353 19.1143 5.07248 19.8097L8.4855 21.8575C8.80219 22.0475 9.19781 22.0475 9.5145 21.8575L12.9275 19.8097C14.0865 19.1143 15.0995 18.2007 15.9104 17.1194C17.2668 15.311 18 13.1113 18 10.8507V3.43811C18 2.79085 17.6343 2.19914 17.0554 1.90967ZM2 10.8507V3.61918C6.20301 1.57608 11.0778 1.47616 15.3465 3.31941L3.3048 15.3611C2.45487 14.0151 2 12.4518 2 10.8507ZM4.57298 16.9213C5.03501 17.3685 5.54763 17.7624 6.10147 18.0947L9 19.8338L11.8985 18.0947C12.8356 17.5325 13.6547 16.7937 14.3104 15.9194C15.4071 14.4572 16 12.6786 16 10.8507V5.49431L4.57298 16.9213Z"/>
    </svg>
  `
};
export {
  e as RevenueProtect
};
